import React from 'react'
import { List, ListItem, ListItemButton, IconButton } from '@mui/material';
import { Trash2 } from 'react-feather'

export const PermissionList = ({ permissions, level = 0, handleClickDemoModal, handleClickDeleteData }) => {
    return (
        <List style={{ paddingLeft: `${level * 20}px` }}>
            {permissions.map((permiso) => (
                <>
                    <ListItem  key={permiso.idpermiso} 
                        disablePadding
                        secondaryAction={
                            <IconButton edge="end" aria-label="delete" onClick={()=>handleClickDeleteData(permiso.idpermiso)} >
                                <Trash2 />
                            </IconButton>
                        }
                    >
                        <ListItemButton
                            onClick={()=>handleClickDemoModal('', 'CREAR PERMISO ', 'FormPermission', { data: permiso })}
                        >
                            {(permiso.nivel === 2)&&(<>+ {permiso.nombrepermisos}</>)}
                            {(permiso.nivel === 3)&&(<i>- {permiso.nombrepermisos}</i>)}
                        </ListItemButton>
                    </ListItem>
                    {permiso.hijos && permiso.hijos.length > 0 && (
                        <PermissionList permissions={permiso.hijos} level={level + 1} handleClickDemoModal={handleClickDemoModal} handleClickDeleteData={handleClickDeleteData}/>
                    )}
                </>
            ))}
        </List>
    );
}
